import "./Products3.module.css";
import Header from "@/reusable_sections/Header";
import ProductosHero from "./sections/ProductosHero";
import CategorAsOverview from "./sections/CategorAsOverview";
import Footer from "@/reusable_sections/Footer";
export default function Products3Page() {
  return <div>
      <Header />
      <ProductosHero />
      <CategorAsOverview />
      <Footer />
    </div>;
}